// extracted by mini-css-extract-plugin
module.exports =  {"prev-upload-info":"prev-upload-info--TFFNA","prevUploadInfo":"prev-upload-info--TFFNA","light":"light--z3B6Z"};